module.exports = require("camelcase");